import { useEffect } from "react";
import { useUserStore } from "../../../store/useUserStore";
import { useUpdateProfile } from "../../../hooks/apis/user";

function Edit_profile() {
  const { user, setUser } = useUserStore((state) => state);
  const { mutate, isLoading, isSuccess } = useUpdateProfile();

  let errors = [];

  const handleUpdateUser = (e) => {
    e.preventDefault();
    document.querySelector(".errors_user").innerHTML = "";

    //Get form data
    const user_fullname = document.querySelector("#eitem-username").value;
    const user_address = document.querySelector("#eitem-address").value;

    //Validate data
    if (user_fullname === "" || user_fullname == null) {
      errors.push({ message: "لطفا نام و نام خانوادگی خود را وارد کنید" });
    }
    if (user_address === "" || user_address == null) {
      errors.push({ message: "لطفا آدرس خود را وارد کنید" });
    }

    //Submit form
    if (errors.length > 0) {
      //Show errors
      let nodes_error = errors.map((err) => {
        let p = document.createElement("p");
        p.textContent = err.message;
        return p;
      });

      document.querySelector(".errors_user").append(...nodes_error);
    } else {
      mutate({
        name: user_fullname,
        gender: "male",
        address: user_address,
      });
    }

    errors = [];
  };

  useEffect(() => {
    if (isSuccess) {
      setUser({
        name: document.querySelector("#eitem-username").value,
        address: document.querySelector("#eitem-address").value,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <h2 className="titleTab">
        <i className="far fa-edit"></i>
        ویرایش اطلاعات من
      </h2>
      <div className="edit_profile">
        <div className="form_data">
          <p className="item">
            <label htmlFor="eitem-phone" className="eitem-name">
              شماره موبایل
            </label>
            <input
              type="text"
              className="eitem-input"
              name="eitem-phone"
              id="eitem-phone"
              disabled="disabled"
              style={{ opacity: "0.5" }}
              defaultValue={user.mobile}
            />
          </p>
          <p className="item">
            <label htmlFor="eitem-username" className="eitem-name">
              نام و نام خانوادگی
            </label>
            <input
              type="text"
              className="eitem-input"
              name="eitem-username"
              id="eitem-username"
              defaultValue={user.name}
            />
          </p>
          {/* <p className="item">
            <label htmlFor="eitem-address" className="eitem-name">
              آدرس
            </label>
            <input
              type="text"
              className="eitem-input"
              name="eitem-address"
              id="eitem-address"
              defaultValue={user.address}
            />
          </p> */}
          <p className="item">
            <input
              onClick={handleUpdateUser}
              type="submit"
              className="eitem-input"
              name="eitem-submit"
              id="eitem-submit"
              value="ثبت تغییرات"
            />
          </p>
          <div
            className={
              isLoading
                ? "active loading position-fixed"
                : "loading position-fixed"
            }
          >
            <img
              src="/images/loading.svg"
              className="img-fluid"
              alt="loading"
            />
          </div>
          <div
            className="errors_user text-center text-warning m-auto"
            style={{ width: "93%" }}
          ></div>
          {isSuccess && (
            <div
              className="seccuss text-white"
              style={{ border: "1px solid green" }}
            >
              <p className="m-0 text-center">پروفایل با موفقیت ویرایش شد</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Edit_profile;
